<template>
  <div>
    <div>
      <ul class="flex border-b border-blue-500 flex-wrap">
        <li
          v-for="tab in tabs"
          class=""
          :class="{
            'is-active': tab.isActive,
            'flex-auto': justifyBetween,
            'flex-shrink-0': !justifyBetween,
          }"
          :key="tab.name"
        >
          <button
            :href="tab.href"
            @click="selectTab(tab)"
            class="block py-2 text-lg border-0 border-b-3"
            :class="{
              'selected-tab': tab.isActive,
              'px-12': !justifyBetween,
            }"
            :disabled="tab.disabled"
          >
            <slot :name="`header-${tab.refName}`">
              {{ tab.name }}
            </slot>
          </button>
        </li>
      </ul>
    </div>

    <slot />
  </div>
</template>

<script>
export default {
  props: {
    justifyBetween: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return { tabs: [] };
  },
  created() {
    this.tabs = this.$children;
  },
  mounted() {
    // Trigger tab change on default tab
    this.tabs.forEach((tab) => {
      if (tab.isActive) {
        this.selectTabByRefName(tab.refName);
      }
    });
    // Indicates to parent the tab is mounted, so that auto tab selection events can happen
    this.$emit("mounted");
  },
  methods: {
    selectTab(selectedTab) {
      if (selectedTab.refName) {
        return this.selectTabByRefName(selectedTab.refName);
      } else {
        return this.selectTabByName(selectedTab.name);
      }
    },
    tabFromRefName(tabRefName) {
      if (!tabRefName) {
        return null;
      }

      return this.tabs.find(
        (tab) =>
          tab.refName &&
          tab.refName.toLowerCase() === tabRefName.trim().toLowerCase()
      );
    },
    /**
     * Select a tab using its reference if found
     * @returns whether the tab was found and selected.
     */
    selectTabByRefName(tabRefName) {
      let requestedTab = this.tabFromRefName(tabRefName);
      if (!requestedTab) {
        return false;
      }

      this.tabs.forEach((tab) => {
        tab.isActive = tab === requestedTab;
      });
      this.$emit("tabChange", tabRefName);
      return true;
    },
    /**
     * Fallback tab selection method (used for backward compatibility)
     * @param tabName
     */
    selectTabByName(tabName) {
      this.tabs.forEach((tab) => {
        tab.isActive = tab.name.toLowerCase() === tabName.trim().toLowerCase();
      });
      this.$emit("tabChange", tabName);
    },
  },
};
</script>

<style lang="postcss" scoped>
.selected-tab {
  @apply font-semibold;
  @apply border-blue-500 rounded-none;
}
</style>
